// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-1vjF7raP","mg10":"mg10-3xknbP_g","title":"title-1mifhXKb"};